import React from "react";
import { Box, SimpleGrid, useColorModeValue, Skeleton, SkeletonText } from "@chakra-ui/react";

/**
 * Lightweight backdrop shown behind the paywall modal.
 * Intentionally avoids mounting the full dashboard (and its API calls) to prevent 402 storms.
 */
export default function PaywallBackdrop(): JSX.Element {
  const bg = useColorModeValue("gray.50", "#0b0b0d");
  const cardBg = useColorModeValue("white", "#151517");
  const border = useColorModeValue("gray.200", "gray.700");

  return (
    <Box minH="100%" bg={bg} p={{ base: 4, md: 6 }} pt={{ base: 8, md: 10 }}>
      <Box
        maxW="1200px"
        mx="auto"
        borderWidth="1px"
        borderColor={border}
        bg={cardBg}
        borderRadius="2xl"
        p={{ base: 4, md: 6 }}
        boxShadow="lg"
      >
        <Skeleton height="44px" borderRadius="xl" mb={5} />
        <SimpleGrid columns={{ base: 1, md: 2, lg: 4 }} spacing={4} mb={6}>
          {Array.from({ length: 4 }).map((_, i) => (
            <Box key={i} borderWidth="1px" borderColor={border} borderRadius="xl" p={4} bg={cardBg}>
              <Skeleton height="14px" mb={3} />
              <Skeleton height="28px" mb={2} />
              <Skeleton height="12px" width="60%" />
            </Box>
          ))}
        </SimpleGrid>
        <Box borderWidth="1px" borderColor={border} borderRadius="xl" p={5} bg={cardBg}>
          <Skeleton height="18px" mb={4} width="40%" />
          <SkeletonText noOfLines={6} spacing="3" />
        </Box>
      </Box>
    </Box>
  );
}

